import { DownloadInfo, AuthMethod } from 'types';
import { SongType } from 'services/api/entities';
import { AnalyticsEventLocation } from '../entities';
import AnalyticsEvent from './analyticsEvent';

const userEvents = {
  downloadEvent: (
    songName: string,
    genre: string,
    downloadInfo: DownloadInfo,
    isAiGenerated: boolean,
    songType: SongType,
    location: AnalyticsEventLocation
  ): AnalyticsEvent =>
    AnalyticsEvent.createEvent('track_downloaded', {
      songName,
      genre,
      downloadInfo,
      isAiGenerated,
      songType,
      location,
    }),
  addedLibrary: (
    id: string,
    songType: SongType,
    location: AnalyticsEventLocation
  ): AnalyticsEvent =>
    AnalyticsEvent.createEvent('added_library', {
      id,
      songType,
      location,
    }),
  removedLibrary: (
    id: string,
    songType: SongType,
    location: AnalyticsEventLocation
  ): AnalyticsEvent =>
    AnalyticsEvent.createEvent('removed_library', {
      id,
      songType,
      location,
    }),
  playSong: (
    songName?: string,
    genre?: string,
    location?: AnalyticsEventLocation
  ): AnalyticsEvent =>
    AnalyticsEvent.createEvent('play_song', {
      songName,
      genre,
      location,
    }),
  userStatus: (isLoggedIn: boolean, isSubscribed: boolean): AnalyticsEvent =>
    AnalyticsEvent.createEvent('user_status', {
      isLoggedIn,
      isSubscribed,
    }),
  register: (method: AuthMethod): AnalyticsEvent =>
    AnalyticsEvent.createEvent('register', {
      method,
      isLoggedIn: true,
    }),
  login: (method: AuthMethod): AnalyticsEvent =>
    AnalyticsEvent.createEvent('login', {
      method,
      isLoggedIn: true,
    }),
  purchaseSuccess: (subscriptionType: string | null): AnalyticsEvent =>
    AnalyticsEvent.createEvent('purchase_success', {
      subscriptionType,
    }),
  purchaseCancel: (subscriptionType: string | null): AnalyticsEvent =>
    AnalyticsEvent.createEvent('purchase_cancel', {
      subscriptionType,
    }),
  trackDetail: (
    songName: string,
    genre: string,
    location: AnalyticsEventLocation
  ): AnalyticsEvent =>
    AnalyticsEvent.createEvent('track_detail', {
      songName,
      genre,
      location,
    }),
  generateButtonClickDetails: (): AnalyticsEvent =>
    AnalyticsEvent.createEvent('generate_click_details_page'),
  storeButtonClicked: (): AnalyticsEvent =>
    AnalyticsEvent.createEvent('store_button_clicked'),

  discoveryBannerClicked: (): AnalyticsEvent =>
    AnalyticsEvent.createEvent('product_spotlight_tile_click'),

  discoveryTileClicked: (tileTitle: string): AnalyticsEvent =>
    AnalyticsEvent.createEvent('discovery_tile_click', {
      tileTitle,
    }),

  affiliateClicked: (): AnalyticsEvent =>
    AnalyticsEvent.createEvent('affiliate_click'),
  upgradeSubscription: (
    buttonLocation: string,
    location: AnalyticsEventLocation | string
  ): AnalyticsEvent =>
    AnalyticsEvent.createEvent('upgrade_button_click', {
      buttonLocation,
      location,
    }),
  profitWellLogin: (userEmail?: string) =>
    AnalyticsEvent.createEvent('start_pw', { pw_user_email: userEmail }),
};

export default userEvents;
